import { Controller } from "@hotwired/stimulus"

// Troca a máscara do campo de documento entre CPF e CNPJ conforme o select de tipo.
// Fica num ancestral comum; targets: select (o tipo) e field (numero_documento).
export default class extends Controller {
  static targets = ["select", "field"]

  connect() {
    if (typeof IMask === "undefined") return
    this.apply()
  }
  disconnect() { if (this.mask) this.mask.destroy() }

  apply() {
    const isCpf = this.selectTarget.value === "CPF"
    const opts = isCpf ? { mask: "000.000.000-00" } : { mask: "00.000.000/0000-00" }
    if (this.mask) this.mask.destroy()
    this.mask = IMask(this.fieldTarget, opts)
  }
}
